import { render, staticRenderFns } from "./StorehouseManage.vue?vue&type=template&id=45db1abd&"
import script from "./StorehouseManage.vue?vue&type=script&lang=js&"
export * from "./StorehouseManage.vue?vue&type=script&lang=js&"
import style0 from "./StorehouseManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports